import { RunIgnoredTrigger } from "types/generated";
import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import Badge from "ds/components/Badge";
import { EyeCrossed } from "components/icons/generated";
import ListEntitiesItem from "components/ListEntitiesItem";

import { COLUMN_GAP, COLUMN_ORDER } from "../constants";
import DriftDetectedCell from "../../components/DriftDetectedCell";
import StackIgnoredRunsElementReason from "./Reason";
import styles from "./styles.module.css";

type StackIgnoredRunsElementProps = {
  run: RunIgnoredTrigger;
};

const StackIgnoredRunsElement = ({ run }: StackIgnoredRunsElementProps) => (
  <ListEntitiesItem
    direction="row"
    align="center"
    grid
    gridTemplate={COLUMN_ORDER}
    gap={COLUMN_GAP}
    padding="x-large"
    className={styles.item}
  >
    <Box>
      <Badge startIcon={EyeCrossed} variant="gray" type="strong" text="Ignored" />
    </Box>
    <Typography tag="p" variant="p-body2">
      <StackIgnoredRunsElementReason ignoredRun={run} />
    </Typography>
    <Box align="center">
      <DriftDetectedCell drifted={false} />
    </Box>
  </ListEntitiesItem>
);

export default StackIgnoredRunsElement;
